const it = {
    login: "Accedi",
    logout: "Esci",
    signIn: "Entra",
    signOut: "Esci",
    profile: "Profilo",
    settings: "Impostazioni",
    digiAirMenuWaiterLogin: "Accesso cameriere DigiAirMenu",
    username: "Nome utente",
    password: "Password",
    pinCode: "PIN",
    yourAuthenticationFailed: "Autenticazione non riuscita",
    language: "Lingua",
    chooseLanguage: "Scegli lingua",
    pageNotFound: "Pagina non trovata",
    backToDashboard: "Torna alla dashboard",
    currentTable: "Tabella attuale",
    table: "Tavolo",
    tables: "Tavoli",
    order: "Ordine",
    orders: "Ordini",
    option: "Opzione",
    additive: "Aggiunta",
    options: "Opzioni",
    additives: "Aggiunte",
    empty: "Vuoto",
    untitledItem: "Senza titolo",
    createdAt: "Creato il",
    free: "Gratis",
    items: "articoli",
    item: "articolo",
    itemsCountOfAll: "{{payCount}} di {{maxCount}}",
    minimum: "minimo",
    maximum: "massimo",
    all: "Tutti",
    unitPrice: "Prezzo unitario",
    email: "Email",
    print: "Stampa",
    orderDetails: "Dettagli ordine",
    noOrders: "Nessun ordine",
    noOrdersAdded: "Nessun ordine aggiunto",
    noAddedItems: "Nessun articolo aggiunto",
    loading: "Caricamento",
    createOrSelectOrderAfterSelectingTable: "Prima seleziona un tavolo, poi crea/seleziona un ordine",
    createOrSelectOrderFirst: "Crea/seleziona prima un ordine",
    customFood: "Articolo personalizzato",
    customFoods: "Articoli personalizzati",
    normalFoodOrDrink: "cibo/bevanda standard",
    sentToKitchen: "Inviato in cucina",
    sendToKitchen: "Invia in cucina",
    orderDelivered: "Ordine consegnato",
    type: "tipo",
    status: "stato",
    paid: "pagato",
    partiallyPaid: "Pagato parzialmente",
    unpaid: "non pagato",
    pending: "In attesa",
    canceled: "Annullato",
    created: "Creato",
    accepted: "Accettato",
    completed: "Completato",
    total: "Totale",
    editOrderItem: "Modifica articolo ordine",
    chooseTable: "Scegli tavolo",
    pickup: "Ritiro",
    suspended: "Sospeso",
    processing: "In preparazione",
    rejected: "Rifiutato",
    delivered: "Consegnato",
    ordersList: "Elenco ordini",
    showOlderOrders: "Mostra ordini precedenti",
    showHistory: "Mostra storico",
    showCanceledOrders: "Mostra ordini annullati",
    showDeliveredOrders: "Mostra ordini consegnati",
    showPaidOrders: "Mostra ordini pagati",
    addNewOrder: "Aggiungi nuovo ordine",
    ordering: "Presa ordine",
    availableFoods: "Articoli disponibili",
    searchByTableName: "Cerca per tavolo",
    gridView: "Vista griglia",
    listView: "Vista elenco",
    Filters: "Filtri",
    availableItems: "Articoli disponibili",
    searchByFoodName: "Cerca per nome piatto",
    allCategories: "Tutte le categorie",
    noCategories: "Nessuna categoria",
    addFood: "Aggiungi articolo",
    editManualItem: "Modifica articolo manuale",
    addManualItem: "Aggiungi articolo manuale",
    sendEmail: "Invia email",
    send: "Invia",
    resendPaymentLink: "Invia di nuovo il link di pagamento",
    iUnderstand: "Capisco",
    no: "No",
    yes: "Sì",
    cancel: "Annulla",
    close: "Chiudi",
    back: "Indietro",
    next: "Avanti",
    previous: "Precedente",
    add: "Aggiungere",
    preview: "Anteprima",
    changeTable: "Cambia tavolo",
    saveChanges: "Salva modifiche",
    confirm: "Conferma",
    selectAll: "Seleziona tutto",
    unselectAll: "Deseleziona tutto",
    clear: "Cancella",
    accept: "Accetta",
    acceptOrder: "Accetta ordine",
    confirmOrder: "Conferma ordine",
    rejectOrder: "Rifiuta ordine",
    pay: "Paga",
    payment: "Pagamento",
    payments: "Pagamenti",
    paymentOf: "Pagamento di",
    itemsToPay: "Articoli da pagare",
    price: "Prezzo",
    basicPrice: "Prezzo base",
    totalPrice: "Prezzo totale",
    discount: "Sconto",
    tip: "Mancia",
    payByCreditCard: "Paga con carta",
    payInCash: "Paga in contanti",
    checkout: "Cassa",
    transaction: "Transazione",
    transactionDetails: "Dettagli transazione",
    paymentType: "Tipo di pagamento",
    paymentStatus: "Stato pagamento",
    totalAmount: "Importo totale",
    openPayments: "Pagamenti aperti",
    openPaymentsReport: "Report pagamenti aperti",
    thisItemPaymentIsAwaitingConfirmation: "Il pagamento di questo articolo è in attesa di conferma",
    yourOrderPaymentIsAwaitingConfirmation: "Questo ordine ha un pagamento in attesa di conferma",
    editableInTime: "Modificabile tra {{minutes}}m {{seconds}}s",
    generalSettings: "Impostazioni generali",
    printMethod: "Metodo di stampa",
    printMethodBrowser: "Finestra di stampa del browser",
    printMethodBluetooth: "Stampante Bluetooth",
    printMethodUsb: "Stampante USB (sperimentale)",
    printMethodExternal: "Stampante / app esterna",
    autoPrint: "Stampa automatica",
    virtualKeyboard: "Tastiera virtuale",
    delivery: "Consegna",
    deliveryAddress: "Indirizzo di consegna",
    deliveryDetails: "Dettagli consegna",
    addDeliveryDetails: "Aggiungi dettagli consegna",
    editDeliveryDetails: "Modifica dettagli consegna",
    createDelivery: "Crea consegna",
    fullAddress: "Indirizzo completo",
    postalCode: "CAP",
    houseNumber: "Numero civico",
    doorNumber: "Numero porta",
    floor: "Piano",
    fullName: "Nome completo",
    phoneNumber: "Numero di telefono",
    deliverySummary: "Riepilogo consegna",
    Error: "Errore",
    unexpectedErrorOccurred: "Si è verificato un errore",
    distance: "Distanza",
    duration: "Durata",
    minutes: "Minuti",
    deliveryPrice: "Prezzo consegna",
    deliveryFee: "Costo consegna",
    itemsPrice: "Prezzo articoli",
    totalReceipt: "Totale scontrino",
    customer: "Cliente",
    pickupDetails: "Dettagli ritiro",
    pickupDate: "Data ritiro",
    pickupTime: "Ora ritiro",
    pickupDatetime: "Data/ora di ritiro richiesta",
    changePickupTime: "Cambia ora di ritiro",
    orderId: "ID ordine",
    orderStatus: "Stato ordine",
    waiter: "Cameriere",
    fromCustomerApp: "Dall'app cliente",
    orderType: "Tipo ordine",
    sendDelivery: "Invia consegna",
    requestCourier: "Richiedi corriere",
    callCourier: "Chiama corriere",
    somethingWentWrong: "Qualcosa è andato storto",

    appLogoAlt: "logo digiAirMenu",
    addDAMToHomeScreen: "Aggiungi DigiAirMenu alla schermata iniziale",
    addToHomeScreen: "Aggiungi alla schermata iniziale",
    installDAM: "Installa DAM",
    transferToDemo: "Passa alla demo",
    transferToLive: "Passa al live",
    row: "Riga",
    count: "quantità",
    step: "passo",
    title: "Titolo",
    freeItems: "articoli gratuiti",
    min: "min",
    max: "max",
    printingFailed: "Stampa non riuscita!",
    checkoutPrintDataUnavailable: "I dati della ricevuta di pagamento non sono disponibili per la stampa",
    printUsingExternalDevice: "Stampa con dispositivo esterno",
    customMenuItems: "Articoli menu personalizzati",
    orderDeliveredConfirmation: "Sei sicuro che questo ordine sia stato consegnato?",
    selectItemsForSendingToKitchen: "Seleziona gli articoli da inviare in cucina",
    ItemDetailsAndStatus: "Dettagli / stato articolo",
    description: "descrizione",
    typeAnythingYouNeed: "Scrivi tutto ciò che serve",
    arrival: "Arrivo",
    late_arrival: "Arrivo in ritardo",
    late_pickup: "Ritiro in ritardo",
    request_new_driver: "Richiedi nuovo autista",
    shipment_destroyed: "Spedizione danneggiata",
    address_not_found: "Indirizzo non trovato",
    late_completed: "Completato in ritardo",
    isPaid: "È pagato",
    listOfOrders: "Elenco ordini",
    listOfolderOrRejectedOrdersTitle: "Vecchi/Rifiutati",
    Layout: "Layout",
    manualItem: "Articolo manuale",
    manualItems: "Articoli manuali",
    areYouSureYouWantToConvertOrderToDemoModeOrder: "Sei sicuro di voler convertire l'ordine <1>{{orderId}}</1> in un ordine demo?",
    areYouSureYouWantToConvertOrderToLiveModeOrder: "Sei sicuro di voler convertire l'ordine <1>{{orderId}}</1> in un ordine live?",
    areYouSureYouWantToSwitchToLiveMode: "Sei sicuro di voler passare alla modalità live?",
    areYouSureYouWantToSwitchToDemoMode: "Sei sicuro di voler passare alla modalità demo?",
    areYouWantDeleteThisItem: "Sei sicuro di voler eliminare questo articolo?",
    areYouWantCancelOrder: "Sei sicuro di voler annullare questo ordine?",
    getEmailLabel: "Inserisci la tua email",
    enterValidEmailErr: "Inserisci un indirizzo email valido.",
    sendReceiptInfo: "Invia dettagli ricevuta",
    sendMenuSms: "Invia link menu",
    sendMenuLinkBySms: "Invia link menu via SMS",
    menuLinkSentSuccessfully: "Link menu inviato correttamente",
    paymentLinkResentSuccessfully: "Link di pagamento inviato correttamente",
    receiverEmail: "Email destinatario",
    receiverPhone: "Telefono destinatario",
    receiverEmailPlaceholder: "esempio@email.com",
    emailIsRequired: "L'email è obbligatoria",
    phoneNumberIsRequired: "Il numero di telefono è obbligatorio",
    emailOrPhoneIsRequired: "Email o numero di telefono obbligatorio",
    invalidEmailFormat: "Formato email non valido",
    selected: "selezionato",
    reset: "Reimposta",
    mobileKeyboard: "Tastiera mobile",
    externalDeliveryOrder: "Ordine delivery esterno",
    externalDeliveryOrderDescription: "Questo ordine deve essere accettato prima della lavorazione",
    waiterDraftOrder: "Ordine creato dal cameriere",
    waiterDraftOrderDescription: "Puoi ancora modificare questo ordine. Confermalo quando tutto è definitivo.",
    completeOrderSetup: "Completa impostazione ordine",
    completeOrderSetupDialogTitle: "Completa i dettagli di consegna e finalizza l'orario dell'ordine",
    acceptOrderDialogTitle: "Accettando questo ordine inizierà la preparazione e la cucina sarà avvisata",
    confirmOrderDialogTitle: "Confermando questo ordine le modifiche saranno bloccate e inizierà la preparazione",
    acceptOrderExternalDescription: "Questo ordine è arrivato dall'esterno. Accettalo per avviare la preparazione o rifiutalo se non puoi evaderlo.",
    confirmOrderWaiterCreatedDescription: "Questo ordine è stato creato dal cameriere. Controllalo e confermalo quando tutti gli articoli sono pronti.",
    acceptOrderWaiterCreatedDescription: "Questo ordine è stato creato dal cameriere. Accettalo per bloccare le modifiche e avviare la preparazione.",
    editingLockedForCustomerOrder: "La modifica è bloccata per gli ordini dei clienti.",
    editingLockedForRejectedOrder: "La modifica è bloccata perché questo ordine è stato rifiutato.",
    editingLockedCustomerOrderAfterAcceptance: "La modifica degli ordini cliente è bloccata dopo l'accettazione.",
    editingLockedAfterConfirmation: "La modifica è bloccata dopo la conferma dell'ordine.",
    editingDoneOrderItemLocked: "Gli articoli già completati non possono più essere modificati.",
    editingPaidOrderItemLocked: "Gli articoli pagati non possono più essere modificati.",
    editingPendingPaymentOrderItemLocked: "Questo articolo non può essere modificato mentre il pagamento è in elaborazione.",
    editingSentToKitchenItemLockedByPermission: "Non hai il permesso di modificare articoli già inviati in cucina.",
    rejectOrderConfirm: "Sei sicuro di voler rifiutare questo ordine?",
    acceptOrderPickupTimeHelperText: "Puoi ritardare l'orario di ritiro fino a <1>30 minuti</1>",
    pleaseEnterPickupTime: "Inserisci un orario di ritiro",
    addToOrders: "aggiungi agli ordini",
    cancelThisOrder: "Annulla questo ordine",
    cancelOrder: "Annulla ordine",
    orderModeChangedToDemoInJSX: "La modalità ordine richiesta è stata cambiata in demo con il titolo '<1>Ordine {{targetOrderId}}</1>'.",
    orderModeChangedToLiveInJSX: "La modalità ordine richiesta è stata cambiata in live con il titolo '<1>Ordine {{targetOrderId}}</1>'.",
    checkoutHasPaidByPosInJSX: "Il <1>pagamento</1> con id <3>{{checkout_id}}</3> dell'<5>ordine {{order_id}}</5> è stato pagato correttamente tramite POS.",
    demo: "Demo",
    demoModeIsActive: "La modalità demo è attiva",
    demoModeAlertMessage: "La modalità demo è destinata esclusivamente a scopi di formazione e test. Il gestore del ristorante è l'unico responsabile dell'utilizzo del sistema e del rispetto di tutte le normative legali applicabili durante il periodo in cui la modalità demo è attiva.",
    normal: "Normale",
    showOrderInTargetMode: "Mostra ordine in modalità {{targetMode}}",
    showOrder: "Mostra ordine",
    openOrderInBackground: "<0>Apri</0> <1>(in background)</1>",
    incomingOrderNotificationTitle: "Nuovo ordine ricevuto",
    incomingOrderNotificationDescription: "È arrivato un ordine cliente. Usa il pulsante sotto per aprirlo in background senza chiudere questa finestra.",
    yesDeleteIt: "Sì, elimina",
    payReport: "Report pagamenti",
    checkoutOperation: "Operazione di cassa",
    baseAmount: "Importo base",
    paidPrice: "Importo pagato",
    paidBy: "Pagato da",
    discountAmount: "Importo sconto",
    tipPrice: "Mancia",
    totalWithTip: "Totale con mancia",
    amountToPay: "Importo da pagare",
    paymentAmount: "Importo pagamento",
    paymentsIncludingDiscounts: "Pagamenti inclusi gli sconti",
    paymentsExcludingDiscounts: "Pagamenti esclusi gli sconti",
    paymentsTakingIntoAccountTheirDiscount: "Pagamenti considerando lo sconto",
    paymentsRegardlessOfTheirDiscount: "Pagamenti senza considerare lo sconto",
    openPaymentsStatistics: "Statistiche pagamenti aperti",
    discountCannotBeLessThanZero: "L'importo dello sconto non può essere inferiore a \"0\"",
    discountCannotBeNegative: "L'importo dello sconto non può essere negativo",
    discountCannotBeMoreThanHundredPercent: "L'importo dello sconto non può superare \"100%\"",
    discountCannotBeMoreThan: "L'importo dello sconto non può superare {{price}}",
    theValueMustBeMoreThan: "Il valore deve essere maggiore di {{price}}",
    theValueMustBeMoreThanBaseAmount: "Il valore deve essere maggiore dell'importo base",
    valueMustBeLessThanOrEqualToMessage: "Il valore deve essere minore o uguale a {{maxPrice}}",
    valueMustBeGreaterThanZeroMessage: "Il valore deve essere maggiore di 0",
    tipAmount: "Importo mancia",
    tipCannotBeNegative: "L'importo della mancia non può essere negativo",
    cardTransfer: "Trasferimento carta",
    noTransactionHasBeenMade: "Non è stata effettuata alcuna transazione",
    backToTransactionsList: "Torna all'elenco transazioni",
    transactionsHistory: "Storico transazioni",
    transactionId: "ID transazione",
    transactionHasBeenSentToYourEmail: "La transazione è stata inviata alla tua email",
    ordersPrice: "Importo ordini",
    updatedAt: "Aggiornato il",
    fromTime: "Da",
    toTime: "A",
    backToOrders: "Torna agli ordini",
    tablesList: "Elenco tavoli",
    backToTablesList: "Torna all'elenco tavoli",
    showDetails: "Mostra dettagli",
    receiptDetailsPage: "Pagina dettagli ricevuta",
    checkoutQrCodeAlt: "Codice QR cassa",
    vat: "IVA",
    net: "Netto",
    tax: "Imposta",
    gross: "Lordo",
    sendingEmailFailed: "Invio email non riuscito!",
    paymentFailed: "Pagamento non riuscito",
    Open_Payments: "Pagamenti aperti",
    report: "Report",
    openPaymentStatistics: "Statistiche pagamento aperto",
    allOrderItemsHaveBeenPaid: "Tutti gli articoli di questo ordine sono stati pagati",
    noItemsHaveBeenAddedInThisOrder: "Nessun articolo è stato aggiunto a questo ordine",
    thisItemHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "Questo articolo è stato pagato tramite POS ed è in attesa di conferma pagamento",
    yourOrderHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "Il tuo ordine è stato pagato tramite POS ed è in attesa di conferma pagamento",
    customItems: "Articoli personalizzati",
    singlePrintMethodDescription: "È attivo un solo metodo di stampa alla volta",
    bluetoothUnavailable: "Bluetooth non è disponibile su questo browser o dispositivo",
    bluetoothSecureContextRequired: "La stampa Bluetooth richiede HTTPS o localhost",
    bluetoothPrinterNotSupported: "La stampante Bluetooth selezionata non è supportata",
    noBluetoothPrinterSelected: "Nessuna stampante Bluetooth selezionata",
    noCompatibleBluetoothPrinterFound: "Nessuna stampante Bluetooth compatibile trovata o selezionata. I browser di solito rilevano solo stampanti BLE/GATT, quindi modelli Bluetooth classici come Epson TM-m30 potrebbero non comparire qui",
    bluetoothAutoPrintRequiresSelection: "Seleziona manualmente una stampante Bluetooth una volta prima di usare la stampa automatica",
    bluetoothPrintingNotSupported: "La stampa Bluetooth non è supportata su questo browser o dispositivo",
    usbUnavailable: "USB non è disponibile su questo browser o dispositivo",
    usbSecureContextRequired: "La stampa USB richiede HTTPS o localhost",
    noCompatibleUsbPrinterFound: "Nessuna stampante USB compatibile trovata o selezionata",
    usbAccessDenied: "Il browser o il sistema operativo ha negato l'accesso alla stampante USB selezionata. Chiudi altre app di stampa e controlla i permessi USB del sistema, poi riprova",
    usbAutoPrintRequiresSelection: "Seleziona manualmente una stampante USB una volta prima di usare la stampa automatica",
    usbPrintingNotSupported: "La stampa USB non è supportata per il dispositivo selezionato",
    printerSize: "Dimensione stampante",
    useExternalPrinter: "Usa stampante esterna",
    bluetoothPrinterDetails: "Puoi inviare la stampa a stampanti Bluetooth oppure disattivare l'opzione per scegliere una stampante collegata a questo dispositivo",
    usbPrinterDetails: "Supporto sperimentale per stampanti USB compatibili ESC/POS su Chrome o Edge desktop. Potresti dover selezionare manualmente la stampante una volta prima di usare la stampa automatica. Su Windows la stampante potrebbe richiedere anche la modalità Vendor Class e un driver compatibile WinUSB per apparire nell'elenco del browser",
    externalPrinterDetails: "Puoi inviare la stampa a stampanti esterne collegate all'app oppure disattivare l'opzione per scegliere una stampante collegata a questo dispositivo",
    autoPrintDescription: "Stampa automaticamente dopo l'accettazione di un ordine o dopo un evento websocket di ordine pagato",
    autoPrintUnavailableForBrowserDescription: "La stampa automatica non è disponibile con la finestra di stampa del browser",
    browserPrintMethodNotice: "La finestra di stampa del browser richiede sempre conferma, quindi le ricevute non possono essere stampate automaticamente",
    selectAllPayablesByDefault: "Seleziona tutti i pagabili per impostazione predefinita",
    selectAllPayablesByDefaultOnThePaymentPage: "Seleziona per impostazione predefinita tutti gli articoli pagabili nella pagina di pagamento",
    virtualKeyboardDescription: "Usa la tastiera interna dell'app nei campi supportati",
    virtualKeyboardInfoLabel: "Aiuto tastiera",
    virtualKeyboardDisableHint: "Se preferisci la tastiera del dispositivo, puoi disattivare questa tastiera in <0>Impostazioni</0>.",
    served: "Servito",
    apartmentEntrance: "Ingresso appartamento",
    extraAddressDetails: "Dettagli indirizzo aggiuntivi",
    dialCode: "Prefisso",
    contactInformationAtPickup: "Informazioni di contatto del destinatario",
    recommended: "consigliato",
    successfulDeliveryRegistration: "Consegna registrata correttamente",
    successfulSendDelivery: "Consegna inviata correttamente",
    withDelivery: "Con consegna",
    deliveryItem: "Articolo consegna",
    pickupTimeLabel: "Ora ritiro ({{format}})",
    pickupTimeBaseLabel: "Ora ritiro base",
    pickupTimeFinalLabel: "Ora ritiro finale",
    dropOffTime: "Ora consegna",
    requestedPickupDatetime: "Data/ora di ritiro richiesta corrente",
    timePickerHour: "Ora",
    timePickerMinute: "Minuto",
    toggleTimeList: "Mostra/nascondi elenco orari",
    pickupTimeInitialShort: "Base",
    orderTiming: "Orario ordine",
    maximumSelectableFreeCountHint: "Numero massimo selezionabile gratis",
    minimumSelectableCountHint: "Numero minimo selezionabile",
    maximumSelectableCountHint: "Numero massimo selezionabile",
    maximumSelectedItemsReached: "È stato raggiunto il numero massimo di articoli selezionati",
    pickupTimeAllowedRangeHint: "Per {{date}}, l'orario di ritiro può essere selezionato da {{start}} a {{end}}.",
    pickupDatetimeNotSetHint: "Nessuna data/ora di ritiro impostata. Puoi scegliere qualsiasi orario di ritiro.",
    pickupDatetimeLimitedDelayHint: "Questa data/ora di ritiro richiesta può essere ritardata fino a <1>30 minuti</1> finché l'ordine è in attesa di accettazione.",
    pickupDatetimeLockedHint: "Per questo ordine è già impostata una data/ora di ritiro.",
    pickupTimeEditableOnlyWhenSuspended: "L'orario di ritiro può essere modificato solo quando l'ordine è sospeso.",
    pleaseEnterPickupDate: "Inserisci una data di ritiro",
    pickupDateMustBeTodayOrTomorrow: "Per gli ordini creati dal cameriere, la data di ritiro deve essere oggi o domani.",
    normalOrderCreationUnavailableTitle: "Gli ordini normali non sono attualmente disponibili",
    normalOrderCreationClosedAllDay: "Il ristorante è chiuso in questo giorno, quindi non è possibile creare ordini.",
    normalOrderCreationClosedAtThisTime: "Il ristorante è attualmente chiuso. Gli ordini possono essere creati durante l'orario di apertura: {{hours}}.",
    waiterOrderNoAvailableOpenSlot: "Nessun orario {{orderType}} valido è disponibile entro l'orario di apertura del ristorante per le date attualmente consentite.",
    pickupDateOutsideOpeningHours: "La data selezionata è fuori dai giorni consentiti per gli ordini {{orderType}}.",
    pickupTimeOutsideOpeningHours: "L'orario selezionato è fuori dall'orario consentito per gli ordini {{orderType}}.",
    openingHoursSelectableRangeHint: "Per {{date}}, l'orario {{orderType}} può essere selezionato da {{start}} a {{end}}.",
    openingHoursClosedDayHint: "{{date}} è chiuso per gli ordini {{orderType}}.",
    openingHoursClosedDayCalendarHint: "Chiuso per questo tipo di ordine",
    openingHoursDisabledDatesHint: "Si possono selezionare solo le date con almeno un orario {{orderType}} disponibile durante l'orario di apertura del ristorante.",
    openingHoursUnavailableTimesHint: "Gli orari non selezionabili sono fuori dall'orario di apertura del ristorante per gli ordini {{orderType}} nella data scelta.",
    deliveryAndPickupOrders: "Ordini con consegna e ritiro",
    payByLink: "Paga tramite link",
    updateDelivery: "Aggiorna consegna",
    sendCourierRequest: "Invia richiesta corriere",
    sentToCourier: "Inviato al corriere",
    noPickupTimeProvidedForThisOrder: "Nessun orario di ritiro indicato per questo ordine",
    pickupTimeCalculationForThisOrderFailed: "Calcolo dell'orario di ritiro non riuscito per questo ordine",
    itemEditFailed: "Modifica dell'articolo non riuscita",
    thisItemCannotBeEdited: "Questo articolo non può essere modificato.",
    problemInReadingItemEssentialDataMessage: "Si è verificato un problema durante la lettura delle informazioni essenziali dell'articolo",
};

export default it;
